import {
  ConnectDeclineReason,
  IConnectContact,
  IIncomingCall,
} from '@epicuro-next/data/connect';
import { createAction, props } from '@ngrx/store';

export const initializeCall = createAction('[Connect] Initialize the call');

export const finalizeCall = createAction('[Connect] Finalize the call');

export const cancelCall = createAction(
  '[Connect] Cancel the ongoing call',
  props<{ roomId: string }>(),
);

export const initializeCallSuccess = createAction(
  '[Connect] Initialize call success',
);

export const initializeCallFailure = createAction(
  '[Connect] Initialize call failure',
);

export const createVideoCall = createAction('[Connect] Create video call');

export const setIncomingCall = createAction(
  '[Connect] Set incoming call state',
  props<{ incomingCall?: IIncomingCall | null }>(),
);

export const removeIncomingCall = createAction(
  '[Connect] Remove incoming call state',
);

export const acceptIncomingCall = createAction(
  '[Connect] Accept the incoming call',
);

export const incomingCallAccepted = createAction(
  '[Connect] Incoming call accepted by user',
  props<{ contact: IConnectContact }>(),
);

export const declineIncomingCall = createAction(
  '[Connect] Decline the incoming call',
  props<{ reason: ConnectDeclineReason }>(),
);

export const setDeclineReason = createAction(
  '[Connect] Set call decline reason',
  props<{ reason?: ConnectDeclineReason }>(),
);
